import { refreshParallax } from "../parallax.js";

/**
 * MotionPreview
 *
 * The page editor holds AOS still by default so every section is visible and
 * stable while editing — otherwise anything with `data-aos` sits at opacity 0
 * until it happens to be scrolled into view. The stillness itself is CSS
 * (`[data-motion="off"]`); this hook only re-arms AOS when motion is switched
 * back on, because AOS measured the page while the overrides were in force.
 */
export const MotionPreview = {
  mounted() {
    this.syncMotion();
  },

  updated() {
    this.syncMotion();
  },

  destroyed() {
    window.clearTimeout(this.refreshTimer);
  },

  syncMotion() {
    refreshParallax(this.el);
    if (this.el.dataset.motion !== "on") return;

    // AOS only tracks elements it saw at init, and the preview is patched in
    // afterwards, so it has to be told to re-collect. A single rAF lands too
    // early — the patch is still in flight and AOS re-measures the old DOM,
    // leaving the sections unregistered (no `aos-init`). Refresh once the
    // patch has settled instead.
    window.clearTimeout(this.refreshTimer);
    this.refreshTimer = window.setTimeout(() => {
      if (window.AOS && typeof window.AOS.refreshHard === "function") {
        window.AOS.refreshHard();
      }
    }, 50);
  },
};
